<template>
  <div v-if="show" class="edi-modal">
    <header class="edi-modal__header">
      <slot name="header"></slot>
    </header>

    <main class="edi-modal__body">
      <slot></slot>
    </main>

    <footer class="edi-modal__footer">
      <slot name="footer"></slot>
    </footer>

    <div class="edi-modal__close-wrapper">
      <a href="#" class="btn-close" @click.prevent.stop="$emit('closeModal')">
        <i class="fa fa-times"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'edi-modal',
  props: {
    show: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '~sass/variables';

.edi-modal {
  position: absolute; z-index: $max-z-index;
  padding: 15px 25px;
  border: 1px solid $color-InfoLibre;
  box-shadow: 4px 4px 8px 0 rgba(0, 0, 0, 0.07);
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 21px;
  background-color: white;
  cursor: default;

  &__close-wrapper {
    position: absolute; top: 0; right: 0;

    .btn-close {
      display: block;
      padding: 2px 5px;
      font-weight: normal;
      font-size: 22px;
      &:hover { text-decoration: none; }

      i {
        width: auto;
        display: block;
        font-weight: inherit;
        font-size: inherit;
        color: #090909 !important;
      }
    }
  }

  &:after {
    content: " ";
    width: 10px;
    height: 10px;
    display: block;
    position: absolute;
    border-top: 1px solid $color-InfoLibre;
    border-left: 1px solid $color-InfoLibre;
    background-color: white;
    transform: rotate(225deg);
  }
}

.edi-modal__header:empty,
.edi-modal__footer:empty { display: none; }

.edi-modal__body {
  color: $gris-5;

  a {
    font-weight: 600;
    color: $amarillo-Socios;
  }
}
</style>
